import { render, staticRenderFns } from "./FlightsMenu.vue?vue&type=template&id=70cfb1fa"
import script from "./FlightsMenu.vue?vue&type=script&lang=js"
export * from "./FlightsMenu.vue?vue&type=script&lang=js"
import style0 from "./FlightsMenu.vue?vue&type=style&index=0&id=70cfb1fa&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports